<script lang="ts">
  interface Props {
    label: string;
    checked: boolean;
    hint?: string;
    testid?: string;
    onchange: (checked: boolean) => void;
  }
  let { label, checked, hint, testid, onchange }: Props = $props();
</script>

<label class="toggle" title={hint}>
  <input
    type="checkbox"
    {checked}
    data-testid={testid}
    onchange={(e) => onchange(e.currentTarget.checked)}
  />
  <span class="track" aria-hidden="true"><span class="thumb"></span></span>
  <span class="label">{label}</span>
</label>

<style>
  .toggle {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 28px;
    cursor: pointer;
  }
  input {
    position: absolute;
    opacity: 0;
    width: 1px;
    height: 1px;
  }
  .track {
    width: 32px;
    height: 18px;
    border-radius: 9px;
    background: rgba(255, 255, 255, 0.12);
    position: relative;
    transition: background 0.15s;
    flex: none;
  }
  .thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: var(--text);
    transition: transform 0.15s;
  }
  input:checked + .track {
    background: var(--accent);
  }
  input:checked + .track .thumb {
    transform: translateX(14px);
  }
  input:focus-visible + .track {
    outline: 2px solid var(--accent);
    outline-offset: 2px;
  }
  .label {
    font-size: 12.5px;
    color: var(--muted);
  }
</style>
